import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { Utils } from "../../common/views/Utils";
import { ShortWebsiteModel } from "../../websites/models/WebsiteModel";
import { WebsiteService } from "../../websites/services/WebsiteService";

export function usePopularWebsiteVM() {
    const service = new WebsiteService();

    const [originalList, setOriginalList] = useState<ShortWebsiteModel[]>([]);
    const [list, setList] = useState<ShortWebsiteModel[]>([]);
    const [listHash, setListHash] = useState<number>(0);

    const [showAll, setShowAll] = useState(false);
    const [filterText, setFilterText] = useState<string>("");
    const [sortByName, setSortByName] = useState<boolean>(false);

    const getList = (count: number) => {
        setOriginalList([]);

        const onResult = (result: IDataResult) => {
            if (result.status === ResponseStatus.success) {
                setOriginalList(result.data);
                generateNewWebsites(result.data, sortByName);
            }
        }

        DataUtils.onRequest(service.getGetTopList(count), onResult);
    }

    const onSort = (sortByName: boolean) => {
        setSortByName(sortByName);
        generateNewWebsites(originalList, sortByName);
    }

    const generateNewWebsites = (list: ShortWebsiteModel[], sortByName: boolean) => {
        const lowfilterText = filterText.toLowerCase();

        if (!Utils.isNullOrEmpty(filterText)) {
            list = list.filter((item) => item.name.toLowerCase().includes(lowfilterText));
        }

        if (sortByName) {
            list = list.sort((a, b) => a.name.localeCompare(b.name));
        } else {
            list = list.sort((a, b) => b.popularity - a.popularity);
        }

        setList(list);
        setListHash(Utils.getRandomKey());
    }

    return {
        list,
        listHash,
        showAll, setShowAll,
        filterText, setFilterText,
        sortByName, setSortByName,
        getList,
        onSort
    }
}